import Sidebar from "../components/Sidebar/Sidebar"
import Topbar from "../components/Topbar/Topbar"
import { useState } from "react"
import { useSelector } from "react-redux"
import { getStoreExperience } from "../utils/storeExperience"
import { resolveStoreCategory } from "../utils/storeCategory"
import GestockAiWidget from "../components/GestockAiWidget"

export function PrivateLayout({ children }: { children: React.ReactNode }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const userdata = useSelector((state: any) => state.UserReducer.userdata)
  const storeCategory = resolveStoreCategory(userdata?.store)
  const experience = getStoreExperience(userdata?.store)

  /*
   * Fashion stores are no longer gated behind a "coming soon" placeholder.
   * The product taxonomy (config/productTaxonomy.js) now gives them real
   * structured product types — sizes, pointures, colours — so clothing, shoes
   * and bag shops get the full application like every other business line.
   */
  void storeCategory

  // ✅ NORMAL FLOW
  return (
    <div className={`flex min-h-screen ${experience.layout.appBgClass}`}>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className={`min-w-0 flex-1 min-h-screen ${experience.shell.sidebarWidthClass} ${experience.layout.mainBgClass}`}>
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <main className="p-6">{children}</main>
      </div>

      {/* 🤖 SPEAKON — floating launcher, available on every page */}
      <GestockAiWidget />
    </div>
  )
}
